export default __webpack_public_path__ + "static/media/img_shop-type05.b37b1a7f.png";